import { render, staticRenderFns } from "./BetslipEmpty.vue?vue&type=template&id=ab3ebb9c&scoped=true"
import script from "./BetslipEmpty.vue?vue&type=script&lang=js"
export * from "./BetslipEmpty.vue?vue&type=script&lang=js"
import style0 from "./BetslipEmpty.vue?vue&type=style&index=0&id=ab3ebb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3ebb9c",
  null
  
)

export default component.exports